/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResourceInsert/view.blocks to change it.
import React from 'react'
import TaskBasket from './TaskBasket/index'



/** @type {import('Simple/types.js').View} */
export default function ResourceInsert({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Automations/Content/Content/SetupAction/Content/Content/Content/Steps/Content/ActiveStep/Automation/ResourceInsert"
  
}) {
  return (<React.Fragment
>
<TaskBasket
  viewPath={`${viewPath}/TaskBasket`}
/>
{children}
</React.Fragment>)
}